import { render, staticRenderFns } from "./ServerAddress.vue?vue&type=template&id=6940fae2&"
import script from "./ServerAddress.vue?vue&type=script&lang=ts&"
export * from "./ServerAddress.vue?vue&type=script&lang=ts&"
import style0 from "./ServerAddress.vue?vue&type=style&index=0&id=6940fae2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports